import { components, DropdownIndicatorProps, GroupBase } from 'react-select';
import { ReactComponent as ChevronDown } from '@assets/images/chevron-down.svg';
import { ReactComponent as ChevronUp } from '@assets/images/chevron-up.svg';

function DropdownIndicator<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: DropdownIndicatorProps<Option, IsMulti, Group>) {
  const { selectProps } = props;
  const { menuIsOpen } = selectProps;
  return (
    <components.DropdownIndicator {...props}>
      {menuIsOpen ? <ChevronUp /> : <ChevronDown />}
    </components.DropdownIndicator>
  );
}

export default DropdownIndicator;
